import React from "react";
import { Outlet, useLocation } from "react-router-dom";
/* Importing stylesheet */
import styles from "./style.module.scss";
import { DashboardHeader, Sidebar } from "../../components/parts";

const Dashboard = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const pageTitle =
    pathname === "/dashboard"
      ? "Welcome to Canco Admin Panel"
      : pathname === "/dashboard/locations"
      ? "Locations"
      : pathname === "/dashboard/gas-plus-locations"
      ? "Gas Plus Locations"
      : pathname === "/dashboard/subAdmin"
      ? "Sub Admin"
      : pathname === "/dashboard/webPromotions"
      ? "Promotions"
      : pathname === "/dashboard/banner"
      ? "Banners"
      : pathname === "/dashboard/communityCare"
      ? "Community Care"
      : pathname === "/dashboard/coffee-promotions"
      ? "Coffee Promotions"
      : pathname === "/dashboard/coffee-promotions/configurations"
      ? "Coffee Promotions - Configurations"
      : pathname === "/dashboard/coffee-promotions/site-rewards"
      ? "Coffee Promotions - Site Rewards"
      : pathname === "/dashboard/coffee-promotions/user-rewards"
      ? "Coffee Promotions - User Rewards"
      : pathname === "/dashboard/push-notification"
      ? "Push Notification"
      : pathname === "/dashboard/propane-promotions"
      ? "Propane Promotions"
      : pathname === "/dashboard/propane-promotions/add"
      ? "Add Propane Promotion"
      : pathname === "/dashboard/propane-promotions/edit"
      ? "Edit Propane Promotion"
      : pathname === "/dashboard/propane-popup"
      ? "Propane Popup"
      : pathname === "/dashboard/propane-popup/add"
      ? "Add Propane Popup"
      : pathname === "/dashboard/propane-popup/edit"
      ? "Edit Propane Popup"
      : pathname === "/dashboard/carousel"
      ? "Carousel"
      : pathname === "/dashboard/carousel/add"
      ? "Add Carousel"
      : pathname === "/dashboard/carousel/edit"
      ? "Edit Carousel"
      : pathname === "/dashboard/addNewLocation"
      ? !location.state
        ? "Add New Location"
        : "Edit Location"
      : pathname === "/dashboard/addBanner"
      ? !location.state
        ? "Add New Banner"
        : "Edit Banner"
      : pathname === "/dashboard/addSubAdmin"
      ? !location.state
        ? "Add Sub Admin"
        : "Edit Sub Admin"
      : pathname === "/dashboard/addPromotion"
      ? !location.state
        ? "Add Promotion"
        : "Edit Promotion"
      : pathname === "/dashboard/addWebPromotion"
      ? !location.state
        ? "Add Promotion"
        : "Edit Promotion"
      : pathname === "/dashboard/addBlog"
      ? !location.state
        ? "Add Post"
        : "Edit Post"
      : pathname === "/dashboard/add-new-gas-plus-location"
      ? !location.state
        ? "Add New Gas Plus Location"
        : "Edit Gas Plus Location"
      : null;
  return (
    <div className={styles.dashboardContainer}>
      <Sidebar />
      <div className={styles.dashboardContentContainer}>
        <div id="popupBlock"></div>
        <DashboardHeader pageTitle={pageTitle} pathName={pathname} />
        <div className={styles.dashboardContent}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
